import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a4af3dde"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invite-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "invite-description" }, "Lade neue Benutzer zu deiner Organisation ein, damit du mit diesen zusammenarbeiten kannst. Anschließend kannst du diesen Benutzer Berechtigungen zuweisen oder sie zu Gruppen hinzufügen.", -1))
const _hoisted_3 = { class: "emails-wrapper" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "E-Mail-Adressen", -1))
const _hoisted_5 = {
  key: 0,
  class: "emails"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hint" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons-round" }, "info"),
  /*#__PURE__*/_createTextVNode(" Drücke "),
  /*#__PURE__*/_createElementVNode("kbd", null, "Enter"),
  /*#__PURE__*/_createTextVNode(" um mehrere Benutzer hinzuzufügen. ")
], -1))
const _hoisted_8 = { class: "actions" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Benutzer einladen")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_input_chip = _resolveComponent("md-input-chip")!
  const _component_md_input_field = _resolveComponent("md-input-field")!
  const _component_md_button = _resolveComponent("md-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      (_ctx.emails && _ctx.emails.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emails, (email, key) => {
              return (_openBlock(), _createBlock(_component_md_input_chip, {
                icon: "email",
                key: key,
                closable: "",
                onClose: ($event: any) => (_ctx.removeEmailAddress(key))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(email), 1)
                ]),
                _: 2
              }, 1032, ["onClose"]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("h5", _hoisted_6, "Keine E-Mail-Adressen hinzugefügt"))
    ]),
    _createVNode(_component_md_input_field, {
      modelValue: _ctx.email,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
      label: "E-Mail-Adresse",
      variant: "filled",
      onKeydown: _ctx.emailKeydown,
      onBlur: _ctx.addEmailAddress,
      error: _ctx.error
    }, null, 8, ["modelValue", "onKeydown", "onBlur", "error"]),
    _hoisted_7,
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_md_button, {
        variant: "filled",
        disabled: !_ctx.emails || _ctx.emails.length <= 0,
        onClick: _ctx.inviteUsers
      }, {
        default: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ])
  ]))
}